import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "TEDxYouth Ljubljana report",
  "description": "",
  "published": "2011-11-22T00:00:00.000Z",
  "redirect_from": ["/blog/tedxyouth-ljubljana-report/swizec/3039"],
  "categories": "Ljubljana, Online Communities, Slovenia, TED, TEDx, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Sunday saw the eighth `}<a parentName="p" {...{
        "href": "http://www.ted.com/tedx",
        "title": "TEDx"
      }}>{`TEDx`}</a>{`event in Ljubljana and through immense luck I was able to attend despite forgetting to reserve a ticket.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/11/photo-1-1024x764.jpg",
        "alt": "Driving a car over the internets",
        "title": "Driving a car over the internets"
      }}></img></p>
    <p>{`Twitter is kind of cool like that, you ask if there's any way to sneak into a sold out event happening the next day, somebody says they don't need their ticket and then does everything needed to get the organizer to change the ticket. Thanks `}<a parentName="p" {...{
        "href": "http://twitter.com/freeeky"
      }}>{`@freeeky`}</a>{` for being awesome like that!`}</p>
    <p>{`I manage to get into the event and two things happened - I couldn't for the life of me connect to the wi-fi, and I was seated in the back back row so was mostly looking at the cameraman's head.`}</p>
    <p>{`Nontheless, it was a kickass event! Really happy I managed to attend.`}</p>
    <p>{`I mostly remember the brilliant talk by Jure Aleksejev - he was the only person there without something specific to show. He had only a message and the flawless rhetoric delivery of someone who is really really good at rhetoric. You can see about five minutes of his talk in my bootleg crappy video, but it should give you some idea of how cool he was to listen to.`}</p>
    <lite-youtube {...{
      "videoid": "jMeYuigkgpY",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`The message was basically that Slovenia is a country doing stupid things. We think we'll be able to fix our economy and become awesome by emulating the large western empires, except we forget we aren't actually a large country and should therefore pay attention to `}<em parentName="p">{`creating`}</em>{` wealth instead of simply shuffling it around.`}</p>
    <p>{`Another brilliant talk was by Luka Manjolovič, if for naught else than he `}<em parentName="p">{`drove a car `}{`_`}{`over the internets. That's right ladies and gentlemen, a `}{`_`}{`live demo`}</em>{` right there on stage. Through the internets! That's guts right there. Oh and it worked too.`}</p>
    <p>{`All the other talks were pretty awesome as well.`}</p>
    <p>{`Jure Brečko deserves a special shout out for being epic enough to give us a candid charming presentation full of natural charm. You can't fake something like that. Plus he invented a cheap and effective way to do some important farm stuff I won't even pretend to understand, a full five hours before deadline! Score!`}</p>
    <p>{`I hate to be a sourpuss, but one presentation stuck out for being ... simply bad. I don't know if it was nerves, or she didn't prepare well, but that was not `}<a parentName="p" {...{
        "href": "http://www.huffingtonpost.com/news/ted",
        "title": "TED"
      }}>{`TED`}</a>{`-level presenting there. Not going to name names, just going to say that it made me giggle when she said with special pride that against what her childhood friend said, she did not end up a garbage collector, nope, she's a graduate sociologist!`}</p>
    <p>{`Yep.`}</p>
    <p>{`On a more positive note. Burekwood was a brilliant cartoon. Kudos to all the 12 year olds for making it, charming story. The perfect way to finish off the `}<a parentName="p" {...{
        "href": "http://www.ted.com/talks",
        "title": "TED Talks"
      }}>{`TED talks`}</a>{`. Can't find the video of burekwood right now, but hopefully the official videos will be available in no time.`}</p>
    <p>{`PS: I wish I had some good pics to show, but I don't`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://midd-blog.com/2011/11/05/tedx-2011-embracing-risk/"
        }}>{`TEDx 2011: Embracing Risk (Live-Blog)`}</a>{` (midd-blog.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://willsmath.wordpress.com/2011/11/18/tedxyouth-play-learn-build-share/"
        }}>{`TEDxYouth : Play, Learn, Build, Share.`}</a>{` (willsmath.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://chaikadai.wordpress.com/2011/11/20/tedx-youth/"
        }}>{`tedx youth`}</a>{` (chaikadai.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.wanderingearl.com/im-in-love-with-ljubljana/"
        }}>{`I'm In Love With Ljubljana`}</a>{` (wanderingearl.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=4651095b-f494-4247-a5a0-eadca00f6aef",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      